import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcTags, IcPlus, IcEdit } from "../../Icons";
import axios from "axios";
import {
  Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";

const VACIO = { name: "", formato: "Directa" };

function ListadoCategorias() {
  const { user } = useContext(AuthContext);
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const [idEdit, setIdEdit] = useState("");
  const [form, setForm] = useState(VACIO);
  const [validaBoton, setValidaBoton] = useState(true);

  const toggle = () => setModal(!modal);
  const set = (campo) => (e) => setForm({ ...form, [campo]: e.target.value });

  useEffect(() => {
    axios.get(URL_CATEGORIAS, auth)
      .then((response) => setCategorias(response.data))
      .catch(() => {});
  }, []); // eslint-disable-line

  function abrirNuevo() { setIdEdit(""); setForm(VACIO); toggle(); }
  function abrirEdit(a) {
    setIdEdit(a._id);
    setForm({ name: a.name || "", formato: a.formato || "Directa" });
    toggle();
  }

  function guardar(event) {
    event.preventDefault();
    if (!form.name) {
      Swal.fire("Falta información", "El nombre es obligatorio", "warning");
      return;
    }
    setValidaBoton(false);

    const peticion = idEdit
      ? axios.patch(`${URL_CATEGORIAS}/${idEdit}`, form, auth)
      : axios.post(URL_CATEGORIAS, form, auth);

    peticion
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: idEdit ? "Editar Categoria" : "Crear Categoria",
          detalle: form.name, user: user.id,
        }, auth);
        setValidaBoton(true);
        toggle();
        Swal.fire("¡Listo!", idEdit ? "Categoría actualizada" : "Categoría creada", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      <Header />
      {user.menu_catalogos ? (
        <div className="card container col-sm-8">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcTags style={{ marginRight: 8, color: "#10b981" }} />
                Categorías
              </h3>
              <p className="page-subtitle">
                El formato define cómo se captura la entrada
              </p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={abrirNuevo}>
                <IcPlus style={{ marginRight: 6 }} />
                Nueva Categoría
              </Button>
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Formato</th>
                <th>Captura</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {categorias
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.name}</td>
                    <td>{a.formato}</td>
                    <td style={{ fontSize: "0.75rem", color: "#64748b" }}>
                      {a.formato === "Transferencia"
                        ? "Se captura lo que hay que Regresar en USD y se convierte con TC"
                        : "Se captura el Monto en MXN y se le restan las comisiones"}
                    </td>
                    <td>
                      <Button color="info" size="sm" onClick={() => abrirEdit(a)}>
                        <IcEdit />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {idEdit ? "Editar Categoría" : "Nueva Categoría"}
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input type="text" value={form.name} required onChange={set("name")} />
          <Label className="mt-2">Formato</Label>
          <Input type="select" value={form.formato} onChange={set("formato")}>
            <option value="Directa">Directa (Huara y Efectivo)</option>
            <option value="Transferencia">Transferencia (USD con TC)</option>
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoCategorias;
